export default __webpack_public_path__ + "static/misc4-83a2d58035e3c2a79f227d5b86bbe219.jpg";